export { default } from './Account';
export type { AccountLayoutProps } from '@v2/shared/lib/types';
